var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import ReactDOM from 'react-dom';
import { AlertLayer as AlertLayerComponent, withFocusLock, } from '@volkswagen-onehub/components-core';
import { LayerContent } from './layer-content';
const Layer = (props) => {
    const { layer, active, scrollElementRef } = props, ownProps = __rest(props, ["layer", "active", "scrollElementRef"]);
    return (React.createElement(AlertLayerComponent, Object.assign({}, ownProps /* Used to pass through the animation props */, { scrollElementRef: (el) => {
            scrollElementRef(ReactDOM.findDOMNode(el));
        }, active: active }),
        React.createElement(LayerContent, { layer: layer })));
};
export const AlertLayer = withFocusLock(Layer);
//# sourceMappingURL=alert.js.map